export const environment = {
  production: true,
  ildatoArticoliDpi: 'https://articoli-monza-polizia-locale.ildato.it/',
  nomeApp: 'Gestione Articoli',
  sottotitolo: 'Monza Polizia Locale',
  altCaption: 'Ildato-ArticoliDpi',
  frontendVersionApiKey: '8aedb1f0-6874-47d5-bb58-cd557354d0a9',
  msClientId: '1aa44a38-4923-4dee-adbe-328461f0f3f9',
  msAuthority:
    'https://login.microsoftonline.com/21fe3236-12b5-4832-8d2a-a402599a851c/v2.0',
  redirectUri: 'https://articoli-monza-polizia-locale.ildato.it/login-entraid',
  accessEndpoint: 'https://articoli-monza-polizia-locale.ildato.it/api',
  frontChannelUrl: 'https://articoli-monza-polizia-locale.ildato.it/login-form',
  authBase: true,
  authAvanzato: true,
};
